import { createCustomMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { MENTIONS_QUERY_CUSTOM_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';
export const MENTIONS_QUERY_METRIC = createCustomMetric({
	key: MENTIONS_QUERY_CUSTOM_KEY,
});
